import { useState } from 'react';
import { labelPositions } from '@/constants/Pdp';
import NextImage from '@/components/ui/next-image';
import { Swiper, SwiperSlide } from 'swiper/react';
import ProductLabel from '@/components/ui/cards/product-card/ProductLabel';
import Image from '@/components/image';
// import useScreenSize from '@/hooks/display/useDisplay';
import ImageLightBox from './Lightbox';
import ZoomInIcon from '@/components/icons/ZoomInIcon';

const Media = ({ images = [], labels, name, locale }) => {
  const [currentImg, setCurrentImg] = useState(0);
  const [openFancybox, setOpenFancybox] = useState(false);

  // const [imgHovered, setImgHovered] = useState(images?.[0]);
  // const [position, setPosition] = useState({ x: 0, y: 0 });
  // const [isZoomed, setIsZoomed] = useState(false);
  // const { isResponsive } = useScreenSize();
  // useEffect(() => {
  //   setImgHovered(images?.[0]);
  // }, [images]);

  // const handleMouseMove = (e) => {
  //   setIsZoomed(true);
  //   const { left, top, width, height } = e.target.getBoundingClientRect();
  //   const x = ((e.pageX - left) / width) * 100;
  //   const y = ((e.pageY - top) / height) * 100;
  //   setPosition({ x, y });
  // };

  return (
    <>
      <div className='space-y-6 overflow-hidden max-lg:space-y-4.5 max-md:space-y-3.5 max-sm:space-y-2.5'>
        <div className='relative aspect-square w-full overflow-hidden rounded-lg'>
          <Image
            src={images?.[currentImg]?.image}
            alt={name}
            layout='fill'
            loading='eager'
            className='object-contain'

            // style={
            //   isResponsive
            //     ? {
            //         transform: isZoomed ? 'scale(2)' : 'scale(1)',
            //         transformOrigin: `${position.x}% ${position.y}%`,
            //         cursor: `${isZoomed ? 'zoom-out' : 'zoom-in'}`,
            //       }
            //     : {}
            // }
            // onMouseMove={handleMouseMove}
            // onMouseLeave={() => setIsZoomed(false)}
            // onClick={() => setOpenFancybox(true)}
            // onDrag={isResponsive}
          />

          <button
            type='button'
            className={`absolute top-3 cursor-pointer max-sm:hidden ${
              locale === 'en' ? 'right-3' : 'left-3'
            } text-red rounded-full bg-gray-100 p-2 shadow-md`}
          >
            <ZoomInIcon
              onClick={() => setOpenFancybox(true)}
              className='text-primary size-6 max-[768px]:size-4'
            />
          </button>
          <ProductLabel
            labels={labels}
            imageType='album'
            labelPositions={labelPositions}
          />
          {/* <div
            className={`max-lg:hidden ${isZoomed ? 'absolute -end-[400px] top-0 z-50 h-[400px] w-[400px] overflow-hidden rounded-sm border' : 'hidden'}`}
            onMouseEnter={() => setIsZoomed(false)}
          >
            <Image
              src={imgHovered?.image}
              className='size-full'
              alt='Sample Image'
              style={{
                transform: 'scale(2)',
                transformOrigin: `${position.x}% ${position.y}%`,
              }}
            />
          </div> */}
        </div>

        {images?.length > 1 && (
          <div className='relative w-full lg:px-10'>
            <Swiper
              breakpoints={{
                320: { spaceBetween: 13 },
                640: { spaceBetween: 16 },
                768: { spaceBetween: 19 },
                1024: { spaceBetween: 22 },
              }}
              slidesPerView='auto'
            >
              {images?.map((img, index) => (
                <SwiperSlide
                  key={index}
                  className='max-w-[76px] min-w-[76px] sm:max-w-28 sm:min-w-28 md:max-w-30.5 md:min-w-30.5 lg:max-w-33.5 lg:min-w-33.5'
                >
                  <div
                    className={`flex h-33.5 cursor-pointer overflow-hidden rounded-lg border bg-white p-2 max-sm:h-[76px] sm:h-28 md:h-30.5 ${
                      currentImg === index
                        ? 'border-gray-500'
                        : 'border-gray-300'
                    }`}
                    onClick={() => setCurrentImg(index)}
                  >
                    <NextImage
                      src={img.image}
                      alt={name}
                      width={250}
                      height={250}
                      objectFit='contain'
                    />
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        )}
      </div>
      <ImageLightBox
        images={images}
        open={openFancybox}
        close={setOpenFancybox}
        customClassName='PDPFancyBoxContainer'
      />
    </>
  );
};

export default Media;
